/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

import { jsx } from '@atlaskit/css';
import Suspense from '@atlaskit/react-ufo/suspense';

const LazyRovoOnboardingGifLight = React.lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-onboarding-gif-light" */ './light-version'
		),
);

export const LazyRovoOnboardingGifLightIcon: React.MemoExoticComponent<
	({
		alt,
		testId,
		width,
		height,
	}: {
		alt?: string;
		testId?: string;
		width?: number;
		height?: number;
	}) => JSX.Element
> = React.memo(
	({
		alt = '',
		testId = '',
		width = 352,
		height = 196,
	}: {
		alt?: string;
		testId?: string;
		width?: number;
		height?: number;
	}): JSX.Element => {
		return (
			<Suspense
				interactionName="rovo-conversation-assistant-onboarding-gif-primary"
				fallback={null}
			>
				<LazyRovoOnboardingGifLight alt={alt} testId={testId} width={width} height={height} />
			</Suspense>
		);
	},
);

const LazyRovoOnboardingGifDark = React.lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-onboarding-gif-dark" */ './dark-version'
		),
);

export const LazyRovoOnboardingGifDarkIcon: React.MemoExoticComponent<
	({
		alt,
		testId,
		width,
		height,
	}: {
		alt?: string;
		testId?: string;
		width?: number;
		height?: number;
	}) => JSX.Element
> = React.memo(
	({
		alt = '',
		testId = '',
		width = 352,
		height = 196,
	}: {
		alt?: string;
		testId?: string;
		width?: number;
		height?: number;
	}): JSX.Element => {
		return (
			<Suspense
				interactionName="rovo-conversation-assistant-onboarding-gif-secondary"
				fallback={null}
			>
				<LazyRovoOnboardingGifDark alt={alt} testId={testId} width={width} height={height} />
			</Suspense>
		);
	},
);

const LazyRovoOnboardingGifLightConfluence = React.lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-onboarding-gif-light-connie" */ './light-version-connie'
		),
);

export const LazyRovoOnboardingGifLightIconConfluence: React.MemoExoticComponent<
	({
		alt,
		testId,
		width,
		height,
	}: {
		alt?: string;
		testId?: string;
		width?: number;
		height?: number;
	}) => JSX.Element
> = React.memo(
	({
		alt = '',
		testId = '',
		width = 352,
		height = 196,
	}: {
		alt?: string;
		testId?: string;
		width?: number;
		height?: number;
	}): JSX.Element => {
		return (
			<Suspense
				interactionName="rovo-conversation-assistant-onboarding-gif-primary"
				fallback={null}
			>
				<LazyRovoOnboardingGifLightConfluence
					alt={alt}
					testId={testId}
					width={width}
					height={height}
				/>
			</Suspense>
		);
	},
);

const LazyRovoOnboardingGifDarkConfluence = React.lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-onboarding-gif-dark-connie" */ './dark-version-connie'
		),
);

export const LazyRovoOnboardingGifDarkIconConfluence: React.MemoExoticComponent<
	({
		alt,
		testId,
		width,
		height,
	}: {
		alt?: string;
		testId?: string;
		width?: number;
		height?: number;
	}) => JSX.Element
> = React.memo(
	({
		alt = '',
		testId = '',
		width = 352,
		height = 196,
	}: {
		alt?: string;
		testId?: string;
		width?: number;
		height?: number;
	}): JSX.Element => {
		return (
			<Suspense
				interactionName="rovo-conversation-assistant-onboarding-gif-secondary"
				fallback={null}
			>
				<LazyRovoOnboardingGifDarkConfluence
					alt={alt}
					testId={testId}
					width={width}
					height={height}
				/>
			</Suspense>
		);
	},
);
